module.exports = __webpack_public_path__ + "img/va.2ca530f2.svg";